var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-page w-100 h-100 d-flex flex-column justify-content-center align-items-center"},[_c('h3',[_vm._v("Sorry, we can't find that page")]),_c('p',[_vm._v(" Try going back to the "),_c('router-link',{attrs:{"to":`/customers`}},[_vm._v("customer list")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }